import api from "services/api";
import secureLocalStorage from "react-secure-storage";
import { ICsatPortalNegociacao } from "interfaces/Csat";

export const registrarCsatService = async (payload: ICsatPortalNegociacao) => {

  const token = secureLocalStorage.getItem("@token") as string | null;

  const config = token
    ? { headers: { Authorization: `Bearer ${token}` } }
    : {};

  return api.post("RegistrarCsat", payload, config);

};